import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Divider, Radio, Space, Table} from "antd";
import {Link} from "react-router-dom";
import {setKey} from "../../util/util";
import Icon from "../Icon";

export default () => {

    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])

    const columns = [
        {
            key: 'heroId',
            dataIndex: 'heroId',
            title: t('heroListTitle.hero'),
            render: (heroId) => <Link style={{fontSize: '20px'}} to={`/hero/${heroId}`}><Space><Icon type={'hero'} name={heroId} size={28} /><span>{t(`heroName.${heroId}`)}</span></Space></Link>,
            align: 'right',
            sorter: (a, b) => a.heroId - b.heroId,
        },
        {
            key: 'total',
            dataIndex: 'total',
            title: t('heroListTitle.total'),
            align: 'center',
            sorter: (a, b) => a.total - b.total,
        },
        {
            key: 'winPercentage',
            dataIndex: 'winPercentage',
            title: t('heroListTitle.winPercentage'),
            align: 'center',
            render: (percentage) => `${percentage}%`,
            sorter: (a, b) => a.winPercentage - b.winPercentage,
        },
        {
            key: 'pickPercentage',
            dataIndex: 'pickPercentage',
            title: t('heroListTitle.pickPercentage'),
            align: 'center',
            render: (percentage) => `${percentage}%`,
            sorter: (a, b) => a.pickPercentage - b.pickPercentage,
        },
        {
            key: 'banPercentage',
            dataIndex: 'banPercentage',
            title: t('heroListTitle.banPercentage'),
            align: 'center',
            render: (percentage) => `${percentage}%`,
            sorter: (a, b) => a.banPercentage - b.banPercentage,
        },
        // {
        //     key: 'killAverage',
        //     dataIndex: 'killAverage',
        //     title: t('heroListTitle.killAverage'),
        //     align: 'center',
        //     sorter: (a, b) => a.killAverage - b.killAverage,
        // },
        // {
        //     key: 'deathAverage',
        //     dataIndex: 'deathAverage',
        //     title: t('heroListTitle.deathAverage'),
        //     align: 'center',
        //     sorter: (a, b) => a.deathAverage - b.deathAverage,
        // },
        // {
        //     key: 'assistAverage',
        //     dataIndex: 'assistAverage',
        //     title: t('heroListTitle.assistAverage'),
        //     align: 'center',
        //     sorter: (a, b) => a.assistAverage - b.assistAverage,
        // },
        {
            key: 'fighting',
            dataIndex: 'fighting',
            title: t('matchInfo.fightPct'),
            align: 'center',
            render: (fighting) => `${fighting}%`,
            sorter: (a, b) => a.fighting - b.fighting,
        },
        {
            key: 'damageAverage',
            dataIndex: 'damageAverage',
            title: t('heroListTitle.damageAverage'),
            align: 'center',
            sorter: (a, b) => a.damageAverage - b.damageAverage,
        },
        {
            key: 'damagedAverage',
            dataIndex: 'damagedAverage',
            title: t('heroListTitle.damagedAverage'),
            align: 'center',
            sorter: (a, b) => a.damagedAverage - b.damagedAverage,
        },
    ]

    const update = (beginTime) => {
        setLoading(true)
        axios.get(`hero/list`, {
            params: {
                beginTime
            }
        }).then(data => {
            setKey(data, 'heroId')
            setData(data)
            setLoading(false)
        })
    }

    useEffect(() => {
        update( new Date(Date.parse("2025/11/5 00:00:00")).getTime() )
    }, [])

    return <Space direction={'vertical'} size={30}>
        <Space>
            {new Array(99 - 82 + 1).fill(0).map((_, i) => <Icon key={i + 82} name={i + 82} type={'ico'} size={56} /> )}
        </Space>
        {/*<Divider/>*/}
        <Radio.Group defaultValue={6} onChange={(e) => {
            let beginTime = 0
            switch (e.target.value) {
                case 1:
                    beginTime = 0
                    break
                case 2:
                    beginTime = (new Date().getTime() - 3600 * 24 * 3 * 1000)
                    break
                case 3:
                    beginTime = (new Date().getTime() - 3600 * 24 * 7 * 1000)
                    break
                case 4:
                    beginTime = (new Date().getTime() - 3600 * 24 * 30 * 1000)
                    break
                case 5:
                    beginTime = (new Date().getTime() - 3600 * 24 * 60 * 1000)
                    break
                case 6:
                    beginTime = (new Date(Date.parse("2025/11/5 00:00:00")).getTime())
                    break
            }
            update(beginTime)
        }} >

            <Radio value={6}>{t('heroesCondition.latest')}</Radio>
            <Radio value={5}>{t('heroesCondition.last60days')}</Radio>
            <Radio value={3}>{t('heroesCondition.last7days')}</Radio>


            {/*<Radio value={1}>{t('heroesCondition.all')}</Radio>*/}
            {/*<Radio value={2}>{t('heroesCondition.last3days')}</Radio>*/}
            {/*<Radio value={4}>{t('heroesCondition.last30days')}</Radio>*/}

        </Radio.Group>
        <Table size={'small'} style={{  width: '1200px', }} columns={columns} pagination={false} dataSource={data} loading={loading}/>
    </Space>
}
